import { useLocalI18n } from '@/hooks/useLocalI18n';
import { PretrialActiveFormScheme, VoiceSettingsActiveFormScheme } from '../@x/forms';
import { labelMap } from './label-map';
import { fieldMap } from './field-map';

export const fieldPipeline = (
  fields: PretrialActiveFormScheme | VoiceSettingsActiveFormScheme,
  t: ReturnType<typeof useLocalI18n>['t'],
) => fields.map((x) => (x.type === 'label' ? labelMap(x, t) : fieldMap(x, t)));
